<template>
  <div class="card card-primary card-info card-tabs">
    <div class="card-header p-0 pt-1 pl-1">
      <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link" v-bind:class="activetab == 1 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">1. Department</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:class="activetab == 2 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">2. Designation</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:class="activetab == 3 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">3. Employee</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:class="activetab == 4 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">4. Overtime Details</a>
        </li>
      </ul>
    </div>
    <!-- /.card-header -->
    <!-- form start -->

    <div class="card-body">
      <div class="tab-content active" id="custom-tabs-four-tabContent">
        <div class="tab-pane fade active show" id="custom-tabs-four-home" role="tabpanel" aria-labelledby="custom-tabs-four-home-tab">
          <div class="row" v-show="activetab == 1" id="department">
            <div class="col-md-4 m-b-10">
              <div class="form-group">
                <label>Faculty Type*</label>
                <select required class="form-control" v-model="facType" v-on:change="depChange()">
                  <option value="0" selected disabled>Select</option>
                  <option value="1">Teaching</option>
                  <option value="2">Non-Teaching</option>
                </select>
              </div>
            </div>
            <div class="col-md-12" v-if="facType != '0'">
              <div class="custom-control custom-checkbox checkbox-primary form-check">
                <input type="checkbox" class="custom-control-input" v-on:change="selectallchange()" v-model="selectall" id="all" checked="">
                <label class="custom-control-label" for="all">Departments</label>
              </div>
              <hr />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12" v-for="(item, ind) in departments">
              <div class="custom-control custom-checkbox checkbox-success form-check">
                <input type="checkbox" class="custom-control-input" v-model="item.IsSelected" v-bind:id="'chk' + ind" checked="">
                <label style="font-weight: 500" class="custom-control-label" v-bind:for="'chk' + ind">{{item.DepartmentName}}</label>
              </div>
            </div>
          </div>
          <div class="row" v-show="activetab == 2" id="designation">
            <div class="col-md-12">
              <div class="custom-control custom-checkbox checkbox-primary form-check">
                <input type="checkbox" class="custom-control-input" v-on:change="selectallchange()" v-model="selectall" id="all" checked="">
                <label class="custom-control-label" for="all">Designations</label>
              </div>
              <hr />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12" v-for="(item, ind) in designations">
              <div class="custom-control custom-checkbox checkbox-success form-check">
                <input type="checkbox" class="custom-control-input" v-model="item.IsSelected" v-bind:id="'desk' + ind" checked="">
                <label style="font-weight: 500" class="custom-control-label" v-bind:for="'desk' + ind">{{item.Name}}</label>
              </div>
            </div>
          </div>
          <div class="row" v-show="activetab == 3" id="employee">
            <div class="col-md-12">
              <div class="scrollable" style="margin-top: 7px;">
                <table class="table table-bordered employee-table table-hover">
                  <thead class="bg-info">
                    <tr>
                      <th>Emp. Code</th>
                      <th>Emp. Name</th>
                      <th>Department</th>
                      <th>Designation</th>
                      <th style="width: 10px" style="text-align: center;" align="center">
                        <input type="checkbox" v-model="selectall" value="false" v-on:change="selectallchange()" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in data.EmployeeOvertimeChild">
                      <td>{{item.EmpCode}}</td>
                      <td>{{item.Name}}</td>
                      <td>{{item.Department}}</td>
                      <td>{{item.Designation}}</td>
                      <td style="text-align: center;">
                        <input type="checkbox" v-model="item.IsSelected" v-bind:value="item.IsSelected" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row" v-show="activetab == 4" id="overtime">
            <div class="col-md-4">
              <label>Month</label>
              <select class="form-control" v-model="data.Month">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">Novemeber</option>
                <option value="12">Decemeber</option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Year</label>
              <select class="form-control" v-model="data.Year">
                <option v-bind:value="item" v-for="item in years">{{item}}</option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Date</label>
              <input type="date" autocomplete="off" class="form-control " id="date">
            </div>

            <div id="divEmp" class="col-md-12 " style="margin-top: 7px;">
              <div class="scrollable tableFixHead">
                <table class="table table-bordered emp-table">
                  <thead class="bg-info">
                    <tr>
                      <th>EmpCode</th>
                      <th>Name</th>
                      <th style="width: 100px">WorkingHours</th>
                      <th style="width: 100px">Rate</th>
                      <th style="width: 100px">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in selectedemp">
                      <td>{{item.EmpCode}}</td>
                      <td>{{item.Name}}</td>
                      <td>
                        <input v-model="item.WorkingHour" v-on:change="getTotal(item.EmpCode)" maxlength="4" class="form-control" />
                      </td>
                      <td>
                        <input v-model="item.RatePerHour" class="form-control" v-on:change="getTotal(item.EmpCode)" maxlength="7" />
                      </td>
                      <td>
                        <p>{{item.Total}}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <hr />
          <div class="col-md-12" style="margin-top: 7px">
            <button type="button" v-show="isupdate == false" v-bind:class="activetab == 1 ? 'btn btn-default pull-left  disabled': 'btn btn-default pull-left '" v-on:click="activetab != 1 ? backClick() : ''"><i class="fa fa-angle-left"></i>Back</button>
            <button v-show="activetab != 4" type="button" class="btn btn-success pull-right" style="float:right" v-on:click="nextClick()">
              <span>Next <i class="fa fa-angle-right"></i></span>
            </button>
          </div>
        </div>
        <!-- /.tab-content -->
      </div>
    </div>
    <!--Button -->
    <div class="card-footer" style="text-align: right; padding-right: 32px; margin-top: 10px">
      <button type="button" class="btn btn-success" v-show="isupdate == false" v-on:click="save()">Save</button>
      <button type="button" class="btn btn-success" v-on:click="update()" v-show="isupdate == true && data.Post == false">Update</button>
      <button type="button" class="btn btn-primary" v-on:click="post()" v-show="isupdate == true && data.Post == false">Post</button>
      <button type="button" class="btn btn-danger" runat="server" id="btnCancel" onserverclick="btnCancel_ServerClick">Cancel</button>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        isupdate: false,
        data: { Month: 0, Year: 0, Date: '', Post: false, EmployeeOvertimeChild: [] },
        bonustypes: [],
        years: [],
        selectall: false,
        departments: [],
        designations: [],
        employees: [],
        activetab: 1,
        selectedemp: [],
        percentage: '',
        facType: 0,
      }
    },
    created: function () {
    },
    mounted: function () {
      this.checkUpdate();
    },
    methods: {
      checkUpdate() {
        startReq();
        var vm = this;
        axios.post('/api/PayrollApi/checkOvertimeUpdate')
          .then(function (r) {
            var d = new Date();
            var y = d.getFullYear();
            for (var i = y - 1; i < y + 2; i++) {
              vm.years.push(i);
            }

            if (r.data.status) {
              vm.data = r.data.q; 
              vm.data.EmployeeOvertimeChild = r.data.q.EmployeeOvertimeChild;
              vm.selectedemp = vm.data.EmployeeOvertimeChild;
              $('#date').val(vm.data.Date);
              vm.isupdate = true;
              vm.activetab = 4;
            }
            else {
              vm.depChange();
            }
            endReq();
          })
          .catch(function (r) {
            console.log(r);
          });
      },

      loadEmployee() {
        startReq();
        var vm = this;
        axios.post("/api/PayrollApi/loadEmployeesForOvertime", {
          depID: vm.departments.filter((x) => { return x.IsSelected }),
          desID: vm.designations.filter((x) => { return x.IsSelected }),
        })
          .then(function (res) {
            if (res.data.status) {
              vm.data.Month = res.data.m;
              vm.data.Year = res.data.y;
              vm.data.EmployeeOvertimeChild = res.data.q;
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })

      },

      loadDesignation() {
        startReq();
        var vm = this;
        axios.post("/api/PayrollApi/LoadDesignation")
          .then(function (res) {
            if (res.data.status) {
              vm.designations = res.data.des;
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      depChange() {
        startReq();
        var vm = this;
        axios.post("/api/PayrollApi/LoadDepartment?type=" + vm.facType)
          .then(function (res) {
            if (res.data.status) {
              vm.departments = res.data.dep
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      save() {
        var vm = this;
        vm.data.Date = $('#date').val();

        if (vm.data.Date == "") {
          alert("Date is required");
          return;
        }
        startReq();

        var preEmp = vm.data.EmployeeOvertimeChild;
        vm.data.EmployeeOvertimeChild = vm.selectedemp;
        axios.post('/api/PayrollApi/saveOverTime', {
          obj: vm.data,
          dep: vm.departments.filter((x) => { return x.IsSelected }),
          des: vm.designations.filter((x) => { return x.IsSelected }),
        })
          .then(function (res) {
            if (res.data.status) {
              endReq();
              toastr.success("Saved", "Done!");
              vm.clear();
            }
            //else if (rs == "duplicate") {
            //  endReq();
            //  toastr.error("Another record is already saved with this combinations", "Error!");
            //}
            //else {
            //  endReq();
            //  if (rs[0] == "ad") {
            //    toastr.info(rs[1], "Access Denied!")
            //    return;
            //  }
            //  toastr.error("Error", "Error!");
            //}
          })
          .catch(function (res) {

          });

      },

      update() {
        var vm = this;
        vm.data.Date = $('#date').val();

        if (vm.data.Date == "") {
          alert("Date is required");
          return;
        }

        startReq();
        axios.post('/api/PayrollApi/updateOverTime', {
          obj: vm.data
        })
          .then(function (res) {
            if (res.data.status) {
              endReq();
              toastr.success("Saved", "Done!");
              vm.clear();
            }
          })
          .catch(function (res) {

          });
      },

      post() {
        startReq();
        var vm = this;
        vm.data.Date = $('#date').val();
        axios.post('/api/PayrollApi/postOverTime', {
          obj: vm.data
        })
          .then(function (res) {
            if (res.data.status) {
              endReq();
              toastr.success("Saved", "Done!");
              vm.clear();
            }
          })
          .catch(function (res) {

          });

      },

      cancel() {
        window.location.reload();
      },

      methodChange() {
        startReq();
        for (var i = 0; i < this.selectedemp.length; i++) {
          this.selectedemp[i].Percentage = 0;
          this.selectedemp[i].Amount = 0;
        }
        endReq();
      },

      perChange(obj) {
        if (this.data.Method == 'Basic') {
          obj.Amount = ((obj.Basic * obj.Percentage) / 100).toFixed(0);
        }
        else if (this.data.Method == 'Gross') {
          obj.Amount = ((obj.Gross * obj.Percentage) / 100).toFixed(0);
        }
      },

      getTotal(empcode) {
        var obj = this.selectedemp.find(x => x.EmpCode == empcode);
        var i = this.selectedemp.indexOf(obj);
        this.selectedemp[i].Total = (this.selectedemp[i].WorkingHour * this.selectedemp[i].RatePerHour);
      },

      selectallchange() {
        if (this.activetab == 1) {
          for (var i = 0; i < this.departments.length; i++) {
            this.selectall == true ? this.departments[i].IsSelected = true : this.departments[i].IsSelected = false;
          }
        }
        else if (this.activetab == 2) {
          for (var i = 0; i < this.designations.length; i++) {
            this.selectall == true ? this.designations[i].IsSelected = true : this.designations[i].IsSelected = false;
          }
        }
        else if (this.activetab == 3) {
          for (var i = 0; i < this.data.EmployeeOvertimeChild.length; i++) {
            this.selectall == true ? this.data.EmployeeOvertimeChild[i].IsSelected = true : this.data.EmployeeOvertimeChild[i].IsSelected = false;
          }
        }
      },

      nextClick() {

        if (this.activetab == 1) {
          if (this.departments.filter((x) => { return x.IsSelected; }).length > 0) {
            this.loadDesignation();
            this.selectall = false;
          }
          else {
            toastr.error("No Department is selected", "Error!");
            return;
          }
        }
        else if (this.activetab == 2) {
          if (this.designations.filter((x) => { return x.IsSelected; }).length > 0) {
            this.loadEmployee();
            this.selectall = false;
          }
          else {
            toastr.error("No Designation is selected", "Error!");
            return;
          }
        }
        else if (this.activetab == 3) {
          if (this.data.EmployeeOvertimeChild.filter((x) => { return x.IsSelected; }).length > 0) {
            this.selectall = false;
            startReq();
            this.selectedemp = this.data.EmployeeOvertimeChild.filter((x) => { return x.IsSelected; });
            endReq();
          }
          else {
            toastr.error("No Employee is selected", "Error!");
            return;
          }
        }

        this.activetab = Number(this.activetab) + 1;
      },

      backClick() {
        this.activetab = Number(this.activetab) - 1;
      },
    }
  })
  function allowOnlyNumber(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
</script>



// WEBPACK FOOTER //
// src/components/payroll/employeeOvertime.vue